/**
 * Updated to use React Router for client-side navigation
 * Automatically handles internal routes with React Router and external links with regular <a> tags
 */

import * as Headless from '@headlessui/react';
import React, { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export const Link = forwardRef(function Link(
  props: { href: string } & React.ComponentPropsWithoutRef<'a'>,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  const { href, ...otherProps } = props;

  // Check if this is an external link (starts with http/https) or mailto/tel
  const isExternalLink =
    href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:');

  return (
    <Headless.DataInteractive>
      {isExternalLink ? (
        // External links use regular <a> tag with href
        <a href={href} {...otherProps} ref={ref} />
      ) : (
        // Internal links use React Router Link with 'to' prop
        <RouterLink to={href} {...otherProps} ref={ref} />
      )}
    </Headless.DataInteractive>
  );
});
